function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_752_42113)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36 17C36 25.2843 29.2843 38 21 38C12.7157 38 6 25.2843 6 17C6 8.71573 12.7157 2 21 2C29.2843 2 36 8.71573 36 17Z",
  fill: "#50B5FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 39C25.6617 39 29.6736 35.4545 32.4473 31.1481C35.2458 26.8032 37 21.368 37 17C37 8.16344 29.8366 1 21 1C12.1634 1 5 8.16344 5 17C5 21.368 6.7542 26.8032 9.55269 31.1481C12.3264 35.4545 16.3383 39 21 39Z",
  stroke: "white",
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 28V30H19V32L22 29L19 26V28H14ZM23 28H28V30H23V28ZM26 8H16C14.9 8 14 8.9 14 10V24C14 25.1 14.9 26 16 26H26C27.1 26 28 25.1 28 24V10C28 8.9 27.1 8 26 8ZM26 24H16V10H26V24ZM21 15C22.1 15 23 14.1 22.99 13C22.99 11.9 22.09 11 20.99 11C19.89 11 19 11.9 19 13C19 14.1 19.89 15 21 15Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_752_42113",
  x: 0,
  y: 0,
  width: 42,
  height: 48,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.313726 0 0 0 0 0.709804 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_752_42113"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_752_42113",
  result: "shape"
})));

function SvgPensilina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensilina);
export default __webpack_public_path__ + "static/media/pensilina.7b232dd7.svg";
export { ForwardRef as ReactComponent };